import React from 'react'
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { catalogTableLabel } from "../../app/helpers/helperCatalogs";

const NewCatalogRelationProblems = ({ handleChange, values, errors, placeholderVal, field, moduleText, occupation, comboData, defaultData }) => {

  const { t } = useTranslation();

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderColor: errors?.[field] ? "#dc3545" : provided.borderColor,
      boxShadow: errors?.[field] ? "0 0 0 1px #dc3545" : provided.boxShadow
    }),
    option: (provided, state) => ({
      ...provided,

      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      
      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
  };

  return (
    <div className={`col-md-${occupation}`}>
      <label htmlFor={field} className="form-label tit-view">
      {t(`${moduleText}.short.${field}`)}</label>
      <div className="control">
        <Select
          styles={customStyles}
          myFontSize="14px"
          onChange={(event) => handleChange(event, field)}
          
          className={`basic-multi-select txt-view ${errors[field] && "border border-danger"}`}
          classNamePrefix="select"
          name={field}
          
          inputId={field}
          
          value={Array.isArray(values[field]) ? values[field] : (defaultData || [])}
          
          options={comboData}
          getOptionLabel={(option) => catalogTableLabel(option)}
          getOptionValue={(option) => `${option.id}`}
          isClearable={true}
          isSearchable={true}
          placeholder={placeholderVal ? t("combo.placeholder") : null}
          isMulti

        />
        {errors[field] && <pre> <p className="help text-danger">{errors[field]}</p> </pre>}
      </div>
    </div>
  )
}

export default NewCatalogRelationProblems;